var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"liuliu"},[_c('option-header'),_c('div',{staticClass:"header share_center"},[_c('swiper')],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }